import type { FunctionComponent } from 'react';

import { useBetSlice } from '../../../../store/slices/bets/selectors';
import { CurrencyConnected } from '../../../currency/CurrencyConnected';
import { TrophyIconConnected } from '../../../promotionsV2/trophyIcon/TrophyIconConnected';
import { useTotalBetWalletPlaceholder } from '../hooks/useTotalBetWalletPlaceholder';
import { StickyWidthValue } from '../stickyWidthValue/StickyWidthValue';

export const TotalBetValueConnected: FunctionComponent = () => {
  const totalBet = useBetSlice.totalBet();
  const totalBetWidthPlaceholder = useTotalBetWalletPlaceholder();

  return (
    <StickyWidthValue placeholder={totalBetWidthPlaceholder} prefix={<TrophyIconConnected />}>
      <CurrencyConnected value={totalBet} />
    </StickyWidthValue>
  );
};
